import React, { useEffect, useState } from "react";
import { TextField, Typography, InputAdornment, Select, MenuItem, FormControl, InputLabel, OutlinedInput } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { ColorPicker, Space } from "antd";
import { generate, green, presetPalettes, red, orange, yellow, lime, cyan, purple, gray, blue} from '@ant-design/colors';
import '../../../cssfiles/homepage.css';
import Defaultbasicprops from "./Defaultbasicprops";
import { updateselectedbasicprops } from "../../../store/cofig_data";

const genPresets = (presets = presetPalettes) => 
    Object.entries(presets).map(([label, colors]) => ({
        label,
        colors,
    }))

var basicpropsjson = {
    "widgetname": "",
    "font_data": {
        "fontsize": 0,
        "fonttype": "Roboto"
    },
    "size": {
        "x": 0,
        "y": 0,
        "height": 2,
        "width": 3
    },
    "color": {
        "light": {
            "background": "#EDEFEE",
            "text": "#1E8EFA",
            "border": "#008CD7",
            "icon": "#C2CBC8"
        },
        "dark": {
            "background": "#030303",
            "text": "#1E8EFA",
            "border": "#008CD7",
            "icon": "#C2CBC8"
        }
    },
    "border": {
        "borderradius": 8,
        "bordersize": 0
    },
}

export default function Basicprops (props) {
    const theme = useSelector((state) => state.themedata.theme)
    const basicprops = useSelector((state) => state.configdata.editbasicprops)
    const dispatch = useDispatch()

    var Fonttypelist = [
        "Roboto",
        "Arial, sans-serif",
        "Helvetica, sans-serif",
        "Verdana, sans-serif",
        "Trebuchet MS, sans-serif",
        "Gill Sans, sans-serif",
        "Noto Sans, sans-serif",
        "Avantgarde, TeX Gyre Adventor, URW Gothic L, sans-serif",
        "Optima, sans-serif",
        "Arial Narrow, sans-serif",
        "sans-serif",
        "Times, Times New Roman, serif",
        "Didot, serif",
        "Georgia, serif",
        "Palatino, URW Palladio L, serif",
        "Bookman, URW Bookman L, serif",
        "New Century Schoolbook, TeX Gyre Schola, serif",
        "American Typewriter, serif",
        "serif",
        "Andale Mono, monospace",
        "Courier New, monospace",
        "Courier, monospace",
        "FreeMono, monospace",
        "OCR A Std, monospace",
        "DejaVu Sans Mono, monospace",
        "monospace"
    ]
    const presets = genPresets({
        red,
        green,
        blue,
        orange, 
        yellow, 
        //lime, 
        //cyan, 
        //purple, 
        //gray,
    })

    const [widgetname, setWidgetname] = useState("")
    const [fontsize, setFontsize] = useState(0)
    const [fonttype, setFonttype] = useState("")
    const [t_color, setT_color] = useState("#000000")
    const [b_color, setB_color] = useState("#000000")
    const [br_color, setBr_color] = useState("#000000")
    const [bordersize, setBordersize] = useState(0)
    const [borderradius, setBorderradius] = useState(0)
    
     useEffect(() => {
        // Debug the value of basicprops
        console.log("basicprops:", basicprops);

        if (props.type === "New") {
            if (!basicprops || basicprops === "") {
                setWidgetname(Defaultbasicprops.widgetname);
                setFontsize(Defaultbasicprops.font_data.fontsize);
                setFonttype(Defaultbasicprops.font_data.fonttype);

                if (theme === "light") {
                    setT_color(Defaultbasicprops.color.light.text);
                    setB_color(Defaultbasicprops.color.light.background);
                    setBr_color(Defaultbasicprops.color.light.border);
                } else {
                    setT_color(Defaultbasicprops.color.dark.text);
                    setB_color(Defaultbasicprops.color.dark.background);
                    setBr_color(Defaultbasicprops.color.dark.border);
                }

                setBordersize(Defaultbasicprops.border.bordersize);
                setBorderradius(Defaultbasicprops.border.borderradius);

                basicpropsjson.widgetname = Defaultbasicprops.widgetname;
                basicpropsjson.font_data.fontsize = Defaultbasicprops.font_data.fontsize;
                basicpropsjson.font_data.fonttype = Defaultbasicprops.font_data.fonttype;
                basicpropsjson.border.bordersize = Defaultbasicprops.border.bordersize;
                basicpropsjson.border.borderradius = Defaultbasicprops.border.borderradius;
                basicpropsjson.color.light.text = Defaultbasicprops.color.light.text;
                basicpropsjson.color.light.background = Defaultbasicprops.color.light.background;
                basicpropsjson.color.light.border = Defaultbasicprops.color.light.border;
                basicpropsjson.color.dark.text = Defaultbasicprops.color.dark.text;
                basicpropsjson.color.dark.background = Defaultbasicprops.color.dark.background;
                basicpropsjson.color.dark.border = Defaultbasicprops.color.dark.border;

                props.callbackpropsupdate(basicpropsjson);
                dispatch(updateselectedbasicprops(JSON.stringify(basicpropsjson)));
            } else {
                let basicpropsupdate = {};
                try {
                    if (basicprops && basicprops !== "") {
                        basicpropsupdate = JSON.parse(basicprops);
                    }
                } catch (e) {
                    console.error("Error parsing basicprops:", e);
                    basicpropsupdate = {};
                }

                // Safeguard access to nested properties
                basicpropsjson.widgetname = basicpropsupdate.widgetname || "";
                basicpropsjson.font_data.fontsize = basicpropsupdate.font_data?.fontsize || 0;
                basicpropsjson.font_data.fonttype = basicpropsupdate.font_data?.fonttype || "Roboto";
                basicpropsjson.border.bordersize = basicpropsupdate.border?.bordersize || 0;
                basicpropsjson.border.borderradius = basicpropsupdate.border?.borderradius || 0;
                basicpropsjson.color.light.text = basicpropsupdate.color?.light?.text || "#000000";
                basicpropsjson.color.light.background = basicpropsupdate.color?.light?.background || "#FFFFFF";
                basicpropsjson.color.light.border = basicpropsupdate.color?.light?.border || "#CCCCCC";
                basicpropsjson.color.dark.text = basicpropsupdate.color?.dark?.text || "#000000";
                basicpropsjson.color.dark.background = basicpropsupdate.color?.dark?.background || "#333333";
                basicpropsjson.color.dark.border = basicpropsupdate.color?.dark?.border || "#CCCCCC";

                setWidgetname(basicpropsjson.widgetname);
                setFontsize(basicpropsjson.font_data.fontsize);
                setFonttype(basicpropsjson.font_data.fonttype);

                if (theme === "light") {
                    setT_color(basicpropsjson.color.light.text);
                    setB_color(basicpropsjson.color.light.background);
                    setBr_color(basicpropsjson.color.light.border);
                } else {
                    setT_color(basicpropsjson.color.dark.text);
                    setB_color(basicpropsjson.color.dark.background);
                    setBr_color(basicpropsjson.color.dark.border);
                }

                setBordersize(basicpropsjson.border.bordersize);
                setBorderradius(basicpropsjson.border.borderradius);
            }
        }
    }, [])

    useEffect(() => {
            if(theme === 'dark') {
                setT_color(basicpropsjson.color.dark.text)
                setB_color(basicpropsjson.color.dark.background)
                setBr_color(basicpropsjson.color.dark.border)
            } else {
                setT_color(basicpropsjson.color.light.text)
                setB_color(basicpropsjson.color.light.background)
                setBr_color(basicpropsjson.color.light.border)
            }
            props.callbackpropsupdate(basicpropsjson)
    },[theme])

    useEffect(() => {
        console.log("change h ",props.height, props.width)
        basicpropsjson.size.height = props.height
        basicpropsjson.size.width = props.width
    },[props.height, props.width])

  const handlechnagewidgetname = (e) => {
        setWidgetname(e.target.value);
        const updated = {
            ...basicpropsjson,
            widgetname: e.target.value
        };
        props.callbackpropsupdate(updated);
        dispatch(updateselectedbasicprops(JSON.stringify(updated)));
    };

    const handlefontsizechange = (e) => {
        setFontsize(e.target.value);
        const updated = {
            ...basicpropsjson,
            font_data: {
                ...basicpropsjson.font_data,
                fontsize: e.target.value
            }
        };
        props.callbackpropsupdate(updated);
        dispatch(updateselectedbasicprops(JSON.stringify(updated)));
    };

    const handlechangefonttype = (e) => {
        setFonttype(e.target.value);
        const updated = {
            ...basicpropsjson,
            font_data: {
                ...basicpropsjson.font_data,
                fonttype: e.target.value
            }
        };
        props.callbackpropsupdate(updated);
        dispatch(updateselectedbasicprops(JSON.stringify(updated)));
    };

    const handle_t_color = (value) => {
        setT_color(value);
        const updated = {
            ...basicpropsjson,
            color: {
                ...basicpropsjson.color,
                [theme]: {
                    ...basicpropsjson.color[theme],
                    text: value.toHexString()
                }
            }
        };
        props.callbackpropsupdate(updated);
        dispatch(updateselectedbasicprops(JSON.stringify(updated)));
    };

    const handle_b_color = (value) => {
        setB_color(value);
        const updated = {
            ...basicpropsjson,
            color: {
                ...basicpropsjson.color,
                [theme]: {
                    ...basicpropsjson.color[theme],
                    background: value.toHexString()
                }
            }
        };
        props.callbackpropsupdate(updated);
        dispatch(updateselectedbasicprops(JSON.stringify(updated)));
    };

    const handle_br_color = (value) => {
        setBr_color(value);
        const updated = {
            ...basicpropsjson,
            color: {
                ...basicpropsjson.color,
                [theme]: {
                    ...basicpropsjson.color[theme],
                    border: value.toHexString()
                }
            }
        };
        props.callbackpropsupdate(updated);
        dispatch(updateselectedbasicprops(JSON.stringify(updated)));
    };

    const handlebordersize = (e) => {
        setBordersize(e.target.value);
        const updated = {
            ...basicpropsjson,
            border: {
                ...basicpropsjson.border,
                bordersize: e.target.value
            }
        };
        props.callbackpropsupdate(updated);
        dispatch(updateselectedbasicprops(JSON.stringify(updated)));
    };

    const handleborderraius = (e) => {
        setBorderradius(e.target.value);
        const updated = {
            ...basicpropsjson,
            border: {
                ...basicpropsjson.border,
                borderradius: e.target.value
            }
        };
        props.callbackpropsupdate(updated);
        dispatch(updateselectedbasicprops(JSON.stringify(updated)));
    };

    useEffect(() => {
        // Update basic properties based on widget type and sub-type
        if (props.widgetType === "Card" && props.subWidgetType === "Single Value") {
          setFontsize(16);
          setFonttype("Roboto");
          setT_color("#FFC107");
          setB_color("#FFFFFF");
          setBr_color("#FFC107");
        } else if (props.widgetType === "Charts" && props.subWidgetType === "Line Chart") {
          setFontsize(14);
          setFonttype("Arial");
          setT_color("#000000");
          setB_color("#EFEFEF");
          setBr_color("#CCCCCC");
        }
        // Add more conditions for other widget types and sub-types
      }, [props.widgetType, props.subWidgetType]);

    return(
        <div>
            <div style={{ display: 'flex', flexDirection: 'column'}}>
                <div
                    style={{
                        backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF',
                        padding: '10px',
                        marginBottom: '10px'
                    }}
                >
                    <Typography style={{marginBottom: '15px', fontSize: 18, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Title </Typography>
                    <TextField
                        id="Name"
                        label={ <Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}} > Widget Title </Typography> }
                        variant="standard"
                        InputProps={{
                            startAdornment: (
                            <InputAdornment position="start">
                            </InputAdornment>
                            ),
                            style: {
                                color: "var(--PrimaryText)"
                            }
                        }}
                        sx={{width: '300px', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                        value={widgetname}
                        onChange={handlechnagewidgetname}
                    />
                </div>
                <div
                    style={{
                        backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF',
                        padding: '10px',
                        marginBottom: '10px'
                    }}
                >
                    <Typography style={{marginBottom: '15px', fontSize: 18, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Font </Typography>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <TextField
                            id="Fontsize"
                            label={ <Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Font Size </Typography> }
                            variant="standard"
                            type="number"
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                </InputAdornment>
                                ),
                                style: {
                                    color: "var(--PrimaryText)"
                                }
                            }}
                            sx={{width: '300px', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                            value={fontsize}
                            onChange={handlefontsizechange}
                        />

                        <FormControl variant="filled" sx={{ minWidth: 120, width: '300px', marginBottom: '20px', padding: '0px'}}>
                            <InputLabel style={{color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C', fontSize: 18, fontWeight: 400}}> Font Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={fonttype}
                                onChange={handlechangefonttype}
                                //input={<InputLabel sx={{fontSize: '2rem'}} label="Tag" />}
                                label= {<Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Font Type </Typography> }
                                
                                sx={{
                                    border: 0,
                                    width: '300px',
                                    bgcolor: 'transparent',
                                    color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                    fontSize: "18px",
                                    fontFamily: 'Roboto',
                                    fontWeight: 400,
                                    textAlign: 'left',
                                    borderRadius: 0,
                                    marginRight: '0px',
                                    p: 0,
                                    "& .MuiOutlinedInput-root": {
                                        "& fieldset": {
                                        borderColor: "red"
                                        },
                                        "&:hover fieldset": {
                                        borderColor: "yellow"
                                        },
                                        "& .Mui-focused fieldset": {
                                        borderColor: "green"
                                        }
                                    },
                                    '& .MuiOutlinedInput-input': {p: 0},
                                    '& .MuiOutlinedInput-underline': {borderBottom: '2px soild'},
                                    '& .MuiOutlinedInput-underline:before': { borderBottomColor: theme === 'dark' ? '#FFFFFF' : '#3C3C3C' },
                                    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        border: 0,
                                        fontSize: 25 
                                    },
                                    /*'& .MuiOutlinedInput-notchedOutline ': {
                                        width: '122.35px',
                                        //height:'24px',
                                        border: 0,
                                        
                                        padding: 0
                                    },*/
                                    '& .MuiInputLabel-root': { display: 'none', legend: 'none', fontSize: "14px"  },
                                    '& .MuiSelect-select': {
                                        paddingTop: "25px",
                                        paddingBottom: "0px"
                                    }
                                }}
                                //InputLabelProps={{ shrink: true, fontSize: "18px" }}
                                MenuProps={{
                                    PaperProps: {
                                        sx: {
                                            bgcolor: theme === 'dark' ? '#3C3C3C' : '#C1C1C1',
                                            borderBottom: '2px solid #008CD7',
                                            borderRadius: 0,
                                            boxShadow: 'none',
                                            maxHeight: '250px',
                                            overflow: 'auto',
                                            color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C',
                                        }
                                    },
                
                                }}
                            >
                                {
                                    Fonttypelist.map((name) => {
                                        return(
                                            <MenuItem sx={{ fontSize: '16px', fontFamily: 'Roboto', fontWeight: 400, }} value={name}>
                                                {name}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div
                    style={{
                        backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF',
                        padding: '10px',
                        marginBottom: '10px'
                    }}
                >
                    <Typography style={{marginBottom: '15px', fontSize: 18, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Color </Typography>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <div style={{marginBottom: '20px'}}>
                            <Space style={{marginRight: '20px'}}>
                                <ColorPicker 
                                    //presets={presets} 
                                    value={t_color} 
                                    onChangeComplete={(value) => handle_t_color(value)}
                                    size="small"
                                    getPopupContainer={(triggerNode) => {
                                        return triggerNode.parentNode;
                                    }}
                                />
                                <span className={`text_typography`}> Text Color </span>
                            </Space>
                        </div>
                        
                        <div style={{marginBottom: '20px'}}>
                            <Space style={{marginRight: '20px'}}>
                                <ColorPicker 
                                    //presets={presets} 
                                    value={b_color} 
                                    onChangeComplete={(value) => handle_b_color(value)}
                                    size="small"
                                    getPopupContainer={(triggerNode) => {
                                        return triggerNode.parentNode;
                                    }}
                                />
                                <span className={`text_typography`}> Background Color </span>
                            </Space>
                        </div>
                        
                        <div style={{marginBottom: '20px'}}>
                            <Space style={{marginRight: '20px'}}>
                                <ColorPicker 
                                    //presets={presets} 
                                    value={br_color} 
                                    onChangeComplete={(value) => handle_br_color(value)}  
                                    size="small"
                                    getPopupContainer={(triggerNode) => {
                                        return triggerNode.parentNode;
                                    }}
                                />
                                <span className={`text_typography`}> Border Color </span>
                            </Space>
                        </div>
                    </div>
                </div> 
                <div
                    style={{
                        backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF',
                        padding: '10px',
                        marginBottom: '10px'
                    }}
                >
                    <Typography style={{marginBottom: '15px', fontSize: 18, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Border </Typography>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>              
                        <TextField
                            id="bordersize"
                            label={ <Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Border Size </Typography> }
                            variant="standard"
                            type="number"
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                </InputAdornment>
                                ),
                                style: {
                                    color: "var(--PrimaryText)"
                                }
                            }}
                            sx={{width: '300px', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                            value={bordersize}
                            onChange={handlebordersize}
                        />

                        <TextField
                            id="borderradius"
                            label={ <Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Border Radius </Typography> }
                            variant="standard"
                            type="number"
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                </InputAdornment>
                                ),
                                style: {
                                    color: "var(--PrimaryText)"
                                }
                            }}
                            sx={{width: '300px', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                            value={borderradius}
                            onChange={handleborderraius}
                        />
                    </div>
                </div>
                {/*<div
                    style={{
                        backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF',
                        padding: '10px',
                        marginBottom: '10px'
                    }}
                >
                    <Typography style={{marginBottom: '15px', fontSize: 18, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Size </Typography>
                    <div style={{display: 'flex', justifyContent: 'space-between'}}>
                        <TextField
                            id="height"
                            label={ <Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> Height </Typography> }
                            variant="standard"
                            type="number"
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                </InputAdornment>
                                ),
                                style: {
                                    color: "var(--PrimaryText)"
                                }
                            }}
                            sx={{width: '300px', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                            //value={nodename}
                            //onChange={handlechnagenodename}
                        />
                        <TextField
                            id="width"
                            label={ <Typography style={{fontSize: 20, fontWeight: 500, color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}> width </Typography> }
                            variant="standard"
                            type="number"
                            InputProps={{
                                startAdornment: (
                                <InputAdornment position="start">
                                </InputAdornment>
                                ),
                                style: {
                                    color: "var(--PrimaryText)"
                                }
                            }}
                            sx={{width: '300px', marginBottom: '20px', '& .MuiInput-underline:before': { borderBottomColor: "var(--PrimaryText)" }}}
                            //value={nodename}
                            //onChange={handlechnagenodename}
                        />
                    </div>
                </div>*/}
            </div>
        </div>
    )
}